var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUsersIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C363F",
    d: "M4.0938 3a1.7187 1.7187 0 1 1 0 3.4375 1.7187 1.7187 0 0 1 0-3.4375M12 3a1.7187 1.7187 0 1 1 0 3.4373A1.7187 1.7187 0 0 1 12 3M1 9.4174C1 8.1519 2.027 7.125 3.2924 7.125h.9174c.3416 0 .666.0752.9582.2084a2.7 2.7 0 0 0-.0408.4791c0 .8207.3609 1.5576.9302 2.0625H1.4576C1.2063 9.875 1 9.6687 1 9.4174m8.7076.4576h-.015c.5715-.5049.9303-1.2418.9303-2.0625 0-.1633-.0151-.3223-.0409-.4791.2922-.1353.6166-.2084.9582-.2084h.9174c1.2654 0 2.2924 1.027 2.2924 2.2924a.458.458 0 0 1-.4576.4576zM5.8125 7.8125a2.0625 2.0625 0 1 1 4.125 0 2.0625 2.0625 0 0 1-4.125 0M3.75 13.4264c0-1.5813 1.2826-2.8639 2.8639-2.8639H9.136c1.5813 0 2.8639 1.2826 2.8639 2.8639a.5735.5735 0 0 1-.5736.5736H4.3236a.5735.5735 0 0 1-.5736-.5736"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUsersIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/users-icon.827aba7aa75dcc344ae379d7fa9fc67e.svg";